const DEBUG_KEY = "debug";

// Guard against SSR: only touch window/localStorage in the browser
let isDebugOn = false;
if (typeof window !== "undefined") {
  const params = new URLSearchParams(window.location.search);
  const dbgParam = params.get("debug");
  if (dbgParam !== null) {
    try {
      localStorage.setItem(DEBUG_KEY, dbgParam);
    } catch {}
  }
  try {
    isDebugOn = localStorage.getItem(DEBUG_KEY) === "1";
  } catch {
    isDebugOn = false;
  }
}

export { isDebugOn };

export type DebugEntry = {
  ts: number;
  url: string;
  method?: string;
  status?: number;
  requestHeaders?: Record<string, string>;
  responseHeaders?: Record<string, string>;
  bodyPreview?: string;
  error?: string;
};

export const debugLogs: DebugEntry[] = [];
const listeners: Array<() => void> = [];

export function onDebugLogs(listener: () => void) {
  listeners.push(listener);
  return () => {
    const idx = listeners.indexOf(listener);
    if (idx !== -1) listeners.splice(idx, 1);
  };
}

export function debugLog(entry: Omit<DebugEntry, "ts">) {
  if (!isDebugOn) return;
  debugLogs.push({ ts: Date.now(), ...entry });
  for (const l of listeners) l();
}

if (isDebugOn && typeof window !== "undefined" && "addEventListener" in window) {
  window.addEventListener("error", (e) => {
    debugLog({ url: window.location.href, error: e.message });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = (e as PromiseRejectionEvent).reason;
    debugLog({
      url: window.location.href,
      error: reason instanceof Error ? reason.message : String(reason),
    });
  });
}
